<!--作业考试-->
<template>
    <div class="el-Homeination">
        <el-row class="page_content" v-show="laodShow">
            <h1 class="head_title_white">
                <el-row>
                    <el-col :span="12" :title="homeworkName">
                        <span class="limit_line_one">{{ homeworkName }}</span>
                    </el-col>
                    <el-col :span="12">
                        <!-- <span class="djs">考试剩余时间：120 分钟 0 秒</span> -->
                        <el-button type="primary" style="float: right;" :loading="handHomeLoading"
                                   @click="handHomework">提 交
                        </el-button>
                    </el-col>
                </el-row>

            </h1>
            <div class="bg_"></div>
            <el-row>
                <el-container>
                    <el-aside width="380px">
                        <fieldset class="stuInfo">
                            <legend>考生信息</legend>
                            <img :src="rzImg" style="width:100px;height:100px;"/>
                            <p>姓名：{{ studentInfo.studentName }}</p>
                            <p>学号：{{ studentInfo.studentNo }}</p>
                        </fieldset>
                        <el-row class="dtk_all">
                            <el-row style="background-color: rgb(227 234 246);padding: 10px;margin-bottom:10px;">
                                <span style="color:#409EFF;margin-right:10px;font-weight: 700;">答题卡</span>
                                <span style="color:#e6a23c;">{{ numberTopics }} / {{ homeworkInfo.length }}</span>
                                <span style="float:right;">
                                    <span style="background-color: white;padding: 3px 12px;margin-right:10px;"></span>未答题
                                    <span style="background-color: #67c23a;padding: 3px 12px;margin:0 10px;"></span>已答题
                                </span>
                            </el-row>
                            <template v-for='(item,index) in questionMap'>
                                <el-row class="dtk_h" :key="'title'+index">
                                    {{ index }}
                                </el-row>
                                <el-row style="padding: 10px;">
                                    <ul>
                                        <template v-for='(it,ind) in item.list'>
                                            <li :class="answerOrNot(it)" :key="ind+'_c'"
                                                @click="jump(it.homeworkQuestionId)">
                                                {{ Number(item.num) - Number(item.list.length) + ind + 1 }}
                                            </li>
                                        </template>
                                    </ul>
                                </el-row>
                            </template>
                        </el-row>
                    </el-aside>
                    <el-main>
                        <el-row class="all_subject">
                            <template v-for='(item,index) in homeworkInfo'>
                                <template
                                    v-if="index == 0 || (homeworkInfo[index  - 1].homeworkQuestionTypeName != homeworkInfo[index].homeworkQuestionTypeName)">
                                    <h1>{{ item.homeworkQuestionTypeName }}</h1>
                                </template>
                                <template v-if="item.homeworkQuestionTypeConcat == 1">
                                    <el-row :key="index" :class="'jump'+item.homeworkQuestionId">
                                        <el-row class="stem">
                                            <el-row style="float:left;margin-top:3px;margin-right: 10px;">
                                                {{ index + 1 }}.
                                            </el-row>
                                            <el-row style="float:left;width: calc(100% - 50px);"
                                                    v-html="$imgHtml(item.homeworkQuestionStem)"></el-row>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <ul>
                                                    <el-radio-group v-model="radio[item.homeworkQuestionId]"
                                                                    @change="radioChange(item.homeworkQuestionId)">
                                                        <li v-for="(it,inde) in item.homeworkQuestionOptionList">
                                                            <el-radio :label="it.homeworkQuestionOptionOptionSign">
                                                                <el-row style="float: left;"
                                                                        v-html="it.homeworkQuestionOptionOptionSign +'、'"></el-row>
                                                                <el-row style="float: left;"
                                                                        v-html="$imgHtml(it.homeworkQuestionOptionOptionContent)"></el-row>
                                                            </el-radio>
                                                        </li>
                                                    </el-radio-group>
                                                </ul>
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                </template>

                                <template v-if="item.homeworkQuestionTypeConcat == 2">
                                    <el-row :key="index" :class="'jump'+item.homeworkQuestionId">
                                        <el-row class="stem">
                                            <el-row style="float:left;margin-top:3px;margin-right: 10px;">
                                                {{ index + 1 }}.
                                            </el-row>
                                            <el-row style="float:left;width: calc(100% - 50px);"
                                                    v-html="$imgHtml(item.homeworkQuestionStem)"></el-row>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <ul>
                                                    <el-checkbox-group v-model="checkbox[item.homeworkQuestionId]"
                                                                       @change="checkboxChange(item.homeworkQuestionId)">
                                                        <li v-for="(it,inde) in item.homeworkQuestionOptionList">
                                                            <el-checkbox :label="it.homeworkQuestionOptionOptionSign">
                                                                <el-row style="float: left;"
                                                                        v-html="it.homeworkQuestionOptionOptionSign +'、'"></el-row>
                                                                <el-row style="float: left;"
                                                                        v-html="$imgHtml(it.homeworkQuestionOptionOptionContent)"></el-row>
                                                            </el-checkbox>
                                                        </li>
                                                    </el-checkbox-group>
                                                </ul>
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                </template>

                                <template v-if="item.homeworkQuestionTypeConcat == 3">
                                    <el-row :key="index" :class="'jump'+item.homeworkQuestionId">
                                        <el-row class="stem">
                                            <el-row style="float:left;margin-top:3px;margin-right: 10px;">
                                                {{ index + 1 }}.
                                            </el-row>
                                            <el-row style="float:left;width: calc(100% - 50px);"
                                                    v-html="$imgHtml(item.homeworkQuestionStem)"></el-row>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <ul>
                                                    <el-radio-group v-model="judgeQuestion[item.homeworkQuestionId]"
                                                                    @change="judgeQuestionChange(item.homeworkQuestionId)">
                                                        <li>
                                                            <el-radio label="对">对</el-radio>
                                                        </li>
                                                        <li>
                                                            <el-radio label="错">错</el-radio>
                                                        </li>
                                                    </el-radio-group>
                                                </ul>
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                </template>

                                <template v-if="item.homeworkQuestionTypeConcat == 4">
                                    <el-row :key="index" :class="'jump'+item.homeworkQuestionId">
                                        <el-row class="stem">
                                            <el-row style="float:left;margin-top:3px;margin-right: 10px;">
                                                {{ index + 1 }}.
                                            </el-row>
                                            <el-row style="float:left;width: calc(100% - 50px);"
                                                    v-html="$imgHtml(item.homeworkQuestionStem)"></el-row>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="24">
                                                <el-input @blur="shortAnswerBlur(item.homeworkQuestionId)" :rows="3"
                                                          type="textarea" style="margin:10px 0;"
                                                          v-model="shortAnswer[item.homeworkQuestionId]"></el-input>
                                            </el-col>
                                        </el-row>
                                    </el-row>
                                    <el-row style="min-height: 160px;">
                                        <el-upload
                                            :action="uploadUrl" :headers="headers"
                                            list-type="picture-card"
                                            :before-upload="beforeAvatarUpload"
                                            accept=".png,.jpg"
                                            :file-list="shortAnswerImgs[item.homeworkQuestionId]"
                                            :on-preview="handlePictureCardPreview"
                                            :on-success="(res,file)=>{attributeSuccess(item,res,file)}"
                                            :on-remove="(file, fileList)=>{handleRemove(item,fileList)}">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                    </el-row>
                                </template>
                            </template>
                        </el-row>
                    </el-main>
                </el-container>
            </el-row>
        </el-row>

        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

        <!--        <face-recognition v-if="recognitionShow" :faceRecognition="faceRecognition" :collectionType="collectionType"-->
        <!--         :verificationTimes="verificationTimes"-->
        <!--         :studentPhotoUrl="studentPhotoUrl"-->
        <!--        pageName="examinationPage" :key="timer"></face-recognition>-->
        <face-recognition
            v-show="visibleFaceModal"
            :visible="visibleFaceModal"
            :intervalTime="getCurrentFaceConfig.jobPhotoIntervalTime"
            :skip="getCurrentFaceConfig.jobSkipTimes"
            :score="getCurrentFaceConfig.jobFaceScore"
            :photoCount="getCurrentFaceConfig.jobPhotoCount"
            :faceNumber="faceNumber"
            @faceOver="faceRecord"
            @onSkip="()=>visibleFaceModal=false"
            @notCertified="backOff"
            @stopNavigator="faceRecognitionByStop"
        />
    </div>
</template>
<script>
import { getCookieForRoleTag } from "../../common/ulit";
import rzImg from '@/images/user/rz.png';
// import faceRecognition from "@/components/faceRecognition";	//人脸识别
import faceRecognition from "@/components/faceRecognition_K";	//人脸识别
import $ from 'jquery';
import {getStorageKeyForRoleTag, getStudentInfoKeyForRoleTag, getUserIP} from "../../common/ulit";

export default {
    name: "Examination",
    components: {
        faceRecognition
    },
    data() {
        return {
            numberTopics: 0,
            studentInfo: JSON.parse(sessionStorage.getItem(getStudentInfoKeyForRoleTag())),
            homeworkId: this.$route.query.homeworkId,
            homeworkName: this.$Base64.decode(this.$route.query.courseName),
            homeworkStudentId: this.$route.query.homeworkStudentId,
            homeworkInfo: [],
            homeworkStudentInfoList: [],
            radio: {}, //单选题答案
            checkbox: {},//多选题答案
            judgeQuestion: {},//判断题
            shortAnswer: {},//简答题
            questionMap: {},//所有题目map("题目类型：{list:[],mum")
            rzImg: rzImg,
            timer: '',
            url: "",
            recognitionShow: false, //加载完成后显示组件
            laodShow: true, //加载完成后显示整个页面
            faceRecognition: 1, //是否开启人脸 1是 2否
            collectionType: 1, //采集方式 1不可关闭 2可关闭
            verificationTimes: 10, //验证次数
            studentPhotoUrl: "", //照片地址，优先判断照片地址，如果没有则提示去上传学籍照片等待审核
            handHomeLoading: false,
            answerMap: {}, //用于存储学生所选答案，存入一定数量或者是交卷的时候一起提交后台：结构{题目ID：{答案信息}}
            sutdentAllAnswerMap: {}, //学生所有已答答案 结构{题目ID：{答案信息}}交卷时会重新提交全部答案。
            onHomeQuestionId: null,//存储上次点击的题目ID，主要用于多选题时，打完本题后再提交数据
            //===========K=>
            ip: undefined,//当前登录用户的IP
            visibleFaceModal: false,//控制人脸识别弹框是否显示
            tePlanCourseId: "",//当前课程ID
            timer_intervalFaceCheck: null,//间隔调起人脸，定时器
            faceNumber: 0,//人脸识别次数
            //<=K===========

            //上传
            uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
            headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
            dialogImageUrl: '',
            dialogVisible: false,
            shortAnswerImgs:{}, //用于存简答题图片路径
        };
    },
    computed: {
        getCurrSemesterBySession() {
            //主页面【在线学习】中当前学期对应的一些信息
            let data = sessionStorage.getItem(getStudentInfoKeyForRoleTag() + "_onlineLearningRows");
            return JSON.parse(data);//[]
        },
        getAllSemesterBySession() {
            //主页面【在线学习】中所有学期对应的一些信息
            let allData = sessionStorage.getItem(getStudentInfoKeyForRoleTag() + "_onlineLearningAllRows");
            return JSON.parse(allData);
        },
        getSessionInfoByLearning() {
            //从本地缓存中提取关键信息，grade、semesters
            const arr = this.getCurrSemesterBySession;
            const allArr = this.getAllSemesterBySession;
            let obj = {};
            if (Array.isArray(arr) && arr.length > 0) {
                obj = arr[0]
            } else if (Array.isArray(allArr) && allArr.length > 0) {
                obj = allArr[0];
            }
            return obj;
        },
        getCurrentCourse() {
            //当前课程
            return this.tePlanCourseId;
        },
        getStudentInfoByLocal() {
            return JSON.parse(sessionStorage.getItem(getStudentInfoKeyForRoleTag())) || {};
        },
        getStudentId() {
            return this.getStudentInfoByLocal.studentId;
        },
        getStudentSource() {
            //学生图片
            return this.getStudentInfoByLocal.studentSource;
        },
        getFaceRecognitionSetting() {
            return this.$store.getters['faceRecognition/getAll']
        },
        getCurrentFaceConfig() {
            //当前课程对应的权限
            const allAuth = this.getFaceRecognitionSetting;
            if (!Array.isArray(allAuth)) {
                return null;
            }
            const obj = allAuth.find(item => item.courseId === this.getCurrentCourse) || {};
            console.log("当前课程对应权限", obj)
            return {
                ...obj,
                studentPhotoUrl: this.studentPhotoUrl
            }
        },
        getBelongsProject() {
            return '【' + this.homeworkName + '】作业';
        }
    },
    created() {
        if (this.$isEmpty(this.homeworkId) && this.$isEmpty(this.homeworkStudentId)) {
            this.$message({
                message: "课程数据丢失，请返回上一页！",
                type: 'warning'
            });
        } else {
            if (!this.$isEmpty(this.homeworkId)) {
                const param = {
                    homeworkId: this.homeworkId
                }
                this.url = "user/getHomeworkInfo";
                this.getHomeworkInfo(param);
            }
            if (!this.$isEmpty(this.homeworkStudentId)) {
                const param = {
                    homeworkStudentId: this.homeworkStudentId
                }
                this.url = "user/getHomeworkStudentInfo";
                this.getHomeworkInfo(param);
            }
        }
    },
    mounted() {
        getUserIP((ip) => {
            //获取当前登录用户的IP地址
            this.ip = ip;
        })
    },
    beforeDestroyed() {
        clearInterval(this.timer_intervalFaceCheck);
        this.timer_intervalFaceCheck = null;
    },
    methods: {
        attributeSuccess(item,res, file) { //上传成功回调
            if(this.shortAnswerImgs[item.homeworkQuestionId] == null || this.shortAnswerImgs[item.homeworkQuestionId] == ""){
                this.shortAnswerImgs[item.homeworkQuestionId] = [];
            }
            // this.headImg = this.$baseUrl + res.data.url;
            this.shortAnswerImgs[item.homeworkQuestionId].push({
                name:res.data.nameFormat,
                url:this.$baseUrl + res.data.url,
                imgUrl:res.data.url
            }); //写入map
            this.shortAnswerImgs = Object.assign({},this.shortAnswerImgs);
            this.shortAnswerBlur(item.homeworkQuestionId);
        },
        handleRemove(item, fileList) {
            this.shortAnswerImgs[item.homeworkQuestionId] = [];
            for(let key in fileList){
                this.shortAnswerImgs[item.homeworkQuestionId].push(fileList[key]); //写入map
            }
            this.shortAnswerBlur(item.homeworkQuestionId);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeAvatarUpload(file) {
          const isJPG = file.type === 'image/jpeg';
          const isPNG = file.type === 'image/png';
          const isLt5M = file.size / 1024 / 1024 <= 10;

          if (!isJPG && !isPNG) {
            this.$message.error('上传图片只能是 JPG/PNG 格式!');
          }
          if (!isLt5M) {
            this.$message.error('上传图片大小不能超过 10MB!');
          }
          return (isJPG || isPNG) && isLt5M;
        },
        faceRecognitionByStop(type) {
            //如果用户主动取消识别。那么关闭页面
            type !== undefined && this.backOff();
        },
        faceRecord(validateRes, imgPath) {
            //进行人脸识别记录
            // 如果是1，就是成功，清除定时器
            if (validateRes === 1 || validateRes === '1') {
                this.faceNumber = 0;
                clearInterval(this.timer_intervalFaceCheck);
                this.timer_intervalFaceCheck = null;
            }
            this.visibleFaceModal = false;
            // const {grade, semesters} = this.leaningInfo;
            const {grade, semesters} = this.getSessionInfoByLearning || {};
            const params_record = {
                studentId: this.getStudentId,
                courseId: this.tePlanCourseId,
                photoType: "2",
                photoUrl: imgPath,
                ipAddress: this.ip,
                faceResult: validateRes ? '1' : '-1',
                belongsProject: this.getBelongsProject,//所属项目（xxx课件学习，xxx考试等信息）
                grade,
                semesters
            };
            this.$store.dispatch('user/face_record', params_record);
        },
        handleLoad() { //用于重载人脸识别组件
            this.timer = new Date().getTime()
        },
        backOff() {
            this.$closeWin();
        },
        radioChange(homeworkQuestionId) { //单选题选择
            this.onHomeQuestionId = homeworkQuestionId;
            let param = {
                homeworkQuestionId: homeworkQuestionId,
                studentAnswer: this.radio[homeworkQuestionId],
                homeworkQuestionTypeConcat: 1 //展示方式(1单选 2多选 3判断 4简答)
            }
            //this.answerHomework({homeworkQuestionJsonStr:JSON.stringify(param)});//原来的做一个题，提交一次
            this.sutdentAllAnswerMap[homeworkQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.homeworkId), JSON.stringify(this.sutdentAllAnswerMap));//根据homeworkId存入答题缓存，交卷后注意删除

            this.answerMap[homeworkQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.homeworkId), JSON.stringify(this.answerMap));//根据homeworkId存入答题缓存，交卷后注意删除
            if (Object.keys(this.answerMap).length >= 3) {
                this.answerHomework();
            }
        },
        checkboxChange(homeworkQuestionId) { //多选题选择
            let aa = this.checkbox[homeworkQuestionId].sort((a, b) => { //按照abcd排序
                return a.localeCompare(b);
            });
            let param = {
                homeworkQuestionId: homeworkQuestionId,
                studentAnswer: aa.join(","),
                homeworkQuestionTypeConcat: 2 //展示方式(1单选 2多选 3判断 4简答)
            }

            //如果上次点击的题目ID和本次操作的题目ID相同,则表示操作的是同一题目，则不提交数据到后台，只存入缓存
            if (this.$isEmpty(this.onHomeQuestionId) || homeworkQuestionId == this.onHomeQuestionId) {
                this.sutdentAllAnswerMap[homeworkQuestionId] = param; //现在先存入，再提交，
                localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.homeworkId), JSON.stringify(this.sutdentAllAnswerMap));//根据homeworkId存入答题缓存，交卷后注意删除

                this.answerMap[homeworkQuestionId] = param; //现在先存入，再提交，
                localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.homeworkId), JSON.stringify(this.answerMap));//根据homeworkId存入答题缓存，交卷后注意删除
                this.onHomeQuestionId = homeworkQuestionId;
            } else { //操作的不是同一个题目，并且缓存中的数据大于等于3，那么就先提交之前的数据，再存入缓存
                this.onHomeQuestionId = homeworkQuestionId;
                if (Object.keys(this.answerMap).length >= 2) {
                    this.answerHomework(null, param);
                } else {
                    this.sutdentAllAnswerMap[homeworkQuestionId] = param; //现在先存入，再提交，
                    localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.homeworkId), JSON.stringify(this.sutdentAllAnswerMap));//根据homeworkId存入答题缓存，交卷后注意删除

                    this.answerMap[homeworkQuestionId] = param; //现在先存入，再提交，
                    localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.homeworkId), JSON.stringify(this.answerMap));//根据homeworkId存入答题缓存，交卷后注意删除
                }
            }
        },
        judgeQuestionChange(homeworkQuestionId) { //判断题
            this.onHomeQuestionId = homeworkQuestionId;
            let param = {
                homeworkQuestionId: homeworkQuestionId,
                studentAnswer: this.judgeQuestion[homeworkQuestionId],
                homeworkQuestionTypeConcat: 3 //展示方式(1单选 2多选 3判断 4简答)
            }
            //this.answerHomework({homeworkQuestionJsonStr:JSON.stringify(param)});//原来的做一个题，提交一次
            this.sutdentAllAnswerMap[homeworkQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.homeworkId), JSON.stringify(this.sutdentAllAnswerMap));//根据homeworkId存入答题缓存，交卷后注意删除

            this.answerMap[homeworkQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.homeworkId), JSON.stringify(this.answerMap));//根据homeworkId存入答题缓存，交卷后注意删除
            if (Object.keys(this.answerMap).length >= 3) {
                this.answerHomework();
            }
        },
        shortAnswerBlur(homeworkQuestionId) { //简答题
            this.onHomeQuestionId = homeworkQuestionId;
            let imgsList = [];
            if(this.shortAnswerImgs[homeworkQuestionId] != null && this.shortAnswerImgs[homeworkQuestionId] != ""){
                for(let ind in this.shortAnswerImgs[homeworkQuestionId]){
                    imgsList.push(this.shortAnswerImgs[homeworkQuestionId][ind].imgUrl)
                }
            }
            let param = {
                homeworkQuestionId: homeworkQuestionId,
                studentAnswer: this.shortAnswer[homeworkQuestionId],
                studentAnswerImgs:imgsList.length > 0?JSON.stringify(imgsList):"", //图片
                homeworkQuestionTypeConcat: 4 //展示方式(1单选 2多选 3判断 4简答)
            }
            //this.answerHomework({homeworkQuestionJsonStr:JSON.stringify(param)});//原来的做一个题，提交一次

            this.sutdentAllAnswerMap[homeworkQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.homeworkId), JSON.stringify(this.sutdentAllAnswerMap));//根据homeworkId存入答题缓存，交卷后注意删除

            this.answerMap[homeworkQuestionId] = param; //现在先存入，再提交，
            localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.homeworkId), JSON.stringify(this.answerMap));//根据homeworkId存入答题缓存，交卷后注意删除
            if (Object.keys(this.answerMap).length >= 3) {
                this.answerHomework();
            }
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        getHomeworkInfo(param) { //获取作业信息
            const loading = this.$loading({
                lock: true,
                text: '加载作业中......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch(this.url, param).then((ret) => {
                loading.close();
                if (ret.code === 0 || ret.code === '0') {
                    this.recognitionShow = true;
                    if (!this.$isEmpty(ret.faceRecognitionInfo)) {
                        this.faceRecognition = ret.faceRecognitionInfo.faceRecognition; //是否开启人脸 1是 2否
                        this.collectionType = ret.faceRecognitionInfo.collectionType; //采集方式 1不可关闭 2可关闭
                        this.verificationTimes = ret.faceRecognitionInfo.verificationTimes; //验证次数
                        this.studentPhotoUrl = ret.faceRecognitionInfo.studentPhotoUrl; //照片地址，优先判断照片地址，如果没有则提示去上传学籍照片等待审核
                    } else {
                        this.faceRecognition = 2;
                    }
                    if (!this.$isEmpty(ret.data.HomeworkQuestionList)) {
                        let num = 0;
                        let list = 0;
                        //获取所有缓存中已答题目答案
                        let sutdentAllAnswerMap = localStorage.getItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.homeworkId)); //获取之前未提交的题目答案信息
                        this.sutdentAllAnswerMap = !this.$isEmpty(sutdentAllAnswerMap) ? JSON.parse(sutdentAllAnswerMap) : {};
                        //如果缓存中存在数据，则返显回去，如果缓存中的答案与后台的冲突，以前台数据为准

                        ret.data.HomeworkQuestionList.forEach((element, i) => {
                            let stuAnswer = null;
                            if (Object.keys(this.sutdentAllAnswerMap).length > 0 && !this.$isEmpty(this.sutdentAllAnswerMap[element.homeworkQuestionId])) {
                                stuAnswer = this.sutdentAllAnswerMap[element.homeworkQuestionId].studentAnswer; //缓存中的学生答案
                            }

                            if (element.homeworkQuestionTypeConcat == 1) {
                                if (!this.$isEmpty(stuAnswer)) {
                                    this.radio[element.homeworkQuestionId] = stuAnswer;
                                } else {
                                    this.radio[element.homeworkQuestionId] = element.studentAnswer;
                                }
                            } else if (element.homeworkQuestionTypeConcat == 2) {
                                if (!this.$isEmpty(stuAnswer)) {
                                    this.checkbox[element.homeworkQuestionId] = stuAnswer.split(",");
                                } else {
                                    if (!this.$isEmpty(element.studentAnswer)) {
                                        this.checkbox[element.homeworkQuestionId] = element.studentAnswer.split(",");
                                    } else {
                                        this.checkbox[element.homeworkQuestionId] = [];
                                    }
                                }
                            } else if (element.homeworkQuestionTypeConcat == 3) {
                                if (!this.$isEmpty(stuAnswer)) {
                                    this.judgeQuestion[element.homeworkQuestionId] = stuAnswer;
                                } else {
                                    this.judgeQuestion[element.homeworkQuestionId] = element.studentAnswer;
                                }
                            } else if (element.homeworkQuestionTypeConcat == 4) {
                                if (!this.$isEmpty(stuAnswer)) {
                                    this.shortAnswer[element.homeworkQuestionId] = stuAnswer;
                                } else {
                                    this.shortAnswer[element.homeworkQuestionId] = element.studentAnswer;
                                }


                                let studentAnswerImgs = [];
                                if (Object.keys(this.sutdentAllAnswerMap).length > 0 && !this.$isEmpty(this.sutdentAllAnswerMap[element.homeworkQuestionId])) {
                                    if(this.sutdentAllAnswerMap[element.homeworkQuestionId].studentAnswerImgs != null && this.sutdentAllAnswerMap[element.homeworkQuestionId].studentAnswerImgs != ""){
                                        let imgsList = JSON.parse(this.sutdentAllAnswerMap[element.homeworkQuestionId].studentAnswerImgs); //缓存中的学生答案
                                        for(let ind in imgsList){
                                            studentAnswerImgs.push({
                                                name:"",
                                                url:this.$baseUrl + imgsList[ind],
                                                imgUrl:imgsList[ind]
                                            })
                                        }
                                    }else{
                                        if(element.studentAnswerImgs != null && element.studentAnswerImgs != ""){
                                            let imgsList = JSON.parse(element.studentAnswerImgs); //缓存中的学生答案
                                            for(let ind in imgsList){
                                                studentAnswerImgs.push({
                                                    name:"",
                                                    url:this.$baseUrl + imgsList[ind],
                                                    imgUrl:imgsList[ind]
                                                })
                                            }
                                        }
                                    }
                                }else {
                                    if(element.studentAnswerImgs != null && element.studentAnswerImgs != ""){
                                        let imgsList = JSON.parse(element.studentAnswerImgs); //缓存中的学生答案
                                        for(let ind in imgsList){
                                            studentAnswerImgs.push({
                                                name:"",
                                                url:this.$baseUrl + imgsList[ind],
                                                imgUrl:imgsList[ind]
                                            })
                                        }
                                    }
                                }
                                this.shortAnswerImgs[element.homeworkQuestionId] = studentAnswerImgs;
                            }
                            //如果本地答案为空，后台答案不为空，那么将后台数据写入缓存中去
                            if (this.$isEmpty(stuAnswer) && !this.$isEmpty(element.studentAnswer)) {
                                this.sutdentAllAnswerMap[element.homeworkQuestionId] = {
                                    homeworkQuestionId: element.homeworkQuestionId,
                                    studentAnswer: element.studentAnswer,
                                    homeworkQuestionTypeConcat: element.homeworkQuestionTypeConcat //展示方式(1单选 2多选 3判断 4简答)
                                };
                            }

                            if (this.$isEmpty(this.questionMap[element.homeworkQuestionTypeName])) {
                                this.questionMap[element.homeworkQuestionTypeName] = {
                                    list: [],
                                    num: 0
                                };
                            }
                            num = num + 1;
                            this.questionMap[element.homeworkQuestionTypeName].list.push(element);
                            this.questionMap[element.homeworkQuestionTypeName].num = num;
                        });

                        this.radio = Object.assign({}, this.radio);
                        this.checkbox = Object.assign({}, this.checkbox);
                        this.judgeQuestion = Object.assign({}, this.judgeQuestion);
                        this.shortAnswer = Object.assign({}, this.shortAnswer);
                        this.shortAnswerImgs = Object.assign({}, this.shortAnswerImgs);

                        this.homeworkInfo = ret.data.HomeworkQuestionList;
                        this.homeworkStudentInfoList = ret.data.homeworkStudentInfoList;
                        this.homeworkStudentId = ret.data.homeworkStudentId;
                        // if (!this.studentPhotoUrl) {
                        //     this.laodShow = false;
                        //     this.$message({
                        //         message: "未上传学籍照片，请先上传学籍照片等待审核！",
                        //         type: 'warning',
                        //         onClose: () => {
                        //             this.$closeWin();
                        //         }
                        //     });
                        //     return;
                        // }
                        /*
                        * 2023年7月6日 13点41分
                        * 添加作业的四种权限：
                            jobPhotoIntervalTime	作业抓拍间隔吊起时间
                            jobSkipTimes	作业跳过次数配置
                            jobFaceScore	作业人脸识别对比度配置
                            jobPhotoCount	作业抓拍次数
                        * */
                        const tePlanCourseId = ret.data.tePlanCourseId;
                        this.tePlanCourseId = tePlanCourseId;
                        // const findStoreConfigItem = this.$store.commit('faceRecognition/findItem', tePlanCourseId);
                        // if (findStoreConfigItem) {
                        //     (this.visibleFaceModal = true);
                        // } else {
                        this.$store.dispatch('user/getFaceSetting', tePlanCourseId).then(res => {
                            console.log("current play course faceAuth", res)
                            const {code, data} = res;
                            if (code === 0) {
                                const faceConfig = data[0];//Object
                                console.log("this.$store.commit('faceRecognition/add', faceConfig);")
                                this.$store.commit('faceRecognition/add', faceConfig);
                                const {
                                    courseFaceSwitch,
                                    jobPhotoIntervalTime,
                                    jobFaceSwitch
                                } = this.getCurrentFaceConfig;
                                if (jobFaceSwitch !== 1) {
                                    console.log('不需要开启人脸', courseFaceSwitch)
                                    return;
                                }
                                this.visibleFaceModal = faceConfig.assignmentInstate === 1;//初始化开启人脸识别
                                // faceConfig.courseFaceSwitch === 1 && (this.visibleFaceModal = true);
                                //需要间隔吊起人脸
                                const interval = Number.isInteger(jobPhotoIntervalTime) ? jobPhotoIntervalTime * 60 * 1000 : 0;
                                this.timer_intervalFaceCheck = setInterval(() => {
                                    if (this.visibleFaceModal === false) {
                                        this.visibleFaceModal = true;
                                        this.faceNumber++;
                                    }
                                }, interval)
                                this.$forceUpdate();
                                console.log("是否初始化开启人脸识别", faceConfig)
                            }
                        })
                        // }
                        //更新所有已答题目缓存数据
                        localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.homeworkId), JSON.stringify(this.sutdentAllAnswerMap));//根据homeworkId存入答题缓存，交卷后注意删除
                    } else {
                        this.$message({
                            message: "题目数量为空！",
                            type: 'warning',
                            onClose: () => {
                                this.$closeWin();
                            }
                        });
                    }
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning',
                        onClose: () => {
                            this.$closeWin();
                        }
                    });
                }
            }).catch(() => {
                loading.close();
            });
        },
        answerHomework(typeInfo, paramInfo) { //答题
            let param = [];
            if (typeInfo == 1) {
                for (let item in this.sutdentAllAnswerMap) { //转换成需要的格式
                    param.push(this.sutdentAllAnswerMap[item]);
                }
            } else {
                for (let item in this.answerMap) { //转换成需要的格式
                    param.push(this.answerMap[item]);
                }
                if (!this.$isEmpty(paramInfo)) {
                    this.sutdentAllAnswerMap[paramInfo.homeworkQuestionId] = paramInfo; //现在先存入，再提交，
                    localStorage.setItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.homeworkId), JSON.stringify(this.sutdentAllAnswerMap));//根据homeworkId存入答题缓存，交卷后注意删除

                    this.answerMap[paramInfo.homeworkQuestionId] = paramInfo; //现在先存入，再提交，
                    localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.homeworkId), JSON.stringify(this.answerMap));//根据homeworkId存入答题缓存，交卷后注意删除
                }
            }

            this.$store.dispatch("user/answerHomework", {homeworkQuestionJsonStr: JSON.stringify(param)}).then((ret) => {
                if (ret.code != 0 && ret.code != '0') {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                } else {
                    if (typeInfo == 1) { //typeInfo == 1:表是交卷，交卷的时候需要先提交一下答案，答案提交成功后再执行交卷操作
                        this.handHomeLoading = false;
                        this.subHandHome();
                    } else {
                        //提交成功，根据已提交的数据homeworkQuestionId，删除掉this.answerMap中存在的
                        for (let i = 0; i < param.length; i++) {
                            delete this.answerMap[param[i].homeworkQuestionId]; //删除掉已经提交成功的，只剩下未提交成功的数据
                        }
                        localStorage.setItem(getStorageKeyForRoleTag('answerMap_' + this.homeworkId), JSON.stringify(this.answerMap));//根据homeworkId存入答题缓存，交卷后注意删除
                    }
                }
            });
        },
        process_assignmentOutstate() {
            return new Promise((resolve) => {
                if (this.getCurrentFaceConfig.assignmentOutstate === 1) {
                    //交卷时需要根据配置进行人脸识别
                    this.visibleFaceModal = true;
                    this.$watch(() => this.visibleFaceModal, (val) => {
                        if (val === false) {
                            resolve(true);
                        }
                    })
                } else {
                    resolve(true);
                }
            })
        },
        async handHomework(param) { //交卷
            // if (this.getCurrentFaceConfig.assignmentOutstate === 1) {
            //     //交卷时需要根据配置进行人脸识别
            //     this.visibleFaceModal = true;
            //     this.$forceUpdate();
            // }
            await this.process_assignmentOutstate();

            this.$confirm('是否确定提交作业？?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handHomeLoading = true;
                this.answerHomework(1); // 1:表是交卷，交卷的时候需要先提交一下答案，答案提交成功后再执行交卷操作
            }).catch(() => {

            });
        },
        subHandHome() {
            this.$store.dispatch("user/handHomework", {homeworkStudentId: this.homeworkStudentId}).then((ret) => {
                if (ret.code == 0 || ret.code == '0') {
                    localStorage.setItem(getStorageKeyForRoleTag('homeworkName_tag'), 1);
                    localStorage.setItem(getStorageKeyForRoleTag('homeworkName_tag_'), 1);
                    localStorage.removeItem(getStorageKeyForRoleTag('sutdentAllAnswerMap_' + this.homeworkId)); //交卷成功后删除所有答题缓存
                    localStorage.removeItem(getStorageKeyForRoleTag('answerMap_' + this.homeworkId)); //交卷成功后删除答题缓存
                    this.$message({
                        message: ret.msg || "提交成功！",
                        type: 'success',
                        onClose: () => {
                            this.$closeWin();
                        }
                    });
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            });
        },
        jump(index) {
            let total = $(".jump" + index).position().top;
            let top = $(".all_subject").scrollTop(); //当前滚动条的高度
            $(".all_subject").animate({scrollTop: top + total}, 1000);//1000是ms,也可以用slow代替
        },
        answerOrNot(obj) { //是否答题
            this.numberTop();
            if (obj.homeworkQuestionTypeConcat == 1) {
                if (!this.$isEmpty(this.radio[obj.homeworkQuestionId])) {
                    return "yd";
                }
                return "";
            } else if (obj.homeworkQuestionTypeConcat == 2) {
                if (this.checkbox[obj.homeworkQuestionId].length > 0) {
                    return "yd";
                }
                return "";
            } else if (obj.homeworkQuestionTypeConcat == 3) {
                if (!this.$isEmpty(this.judgeQuestion[obj.homeworkQuestionId])) {
                    return "yd";
                }
                return "";
            } else if (obj.homeworkQuestionTypeConcat == 4) {
                if (!this.$isEmpty(this.shortAnswer[obj.homeworkQuestionId]) || (this.shortAnswerImgs[obj.homeworkQuestionId] != null && this.shortAnswerImgs[obj.homeworkQuestionId] != "" && this.shortAnswerImgs[obj.homeworkQuestionId].length > 0)) {
                    return "yd";
                }
                return "";
            }
        },
        numberTop() {
            let this_ = this;
            setTimeout(function () {
                this_.numberTopics = $(".yd").length;
            }, 100);
        }
    }
};
</script>
<style lang="less">
@import '../../styles/base.less';

.el-Homeination {
    .head_title_white {
        color: #000000;
        margin-bottom: 0;

        .djs {
            float: right;
            min-width: 260px;
            font-weight: 100;
            font-size: 17px;
            line-height: 40px;
            margin-left: 10px;
        }
    }

    .head_title {
        margin: 0;
        font-size: 20px;
        margin-right: -20px;
    }

    .bg_ {
        background-color: white;
        margin: 0 -20px;
        border-bottom: 1px solid #f3f3f3;
        margin-bottom: 10px;
    }

    .yd {
        background-color: #67c23a;
        color: #FFFFFF;
    }

    .el-dialog {
        border-radius: 10px;
    }

    .el-main {
        background-color: white;
        padding: 0 20px !important;
        border: 1px solid #e3eaf6;
        margin-left: 10px;
        border-radius: 5px;
        margin-top: 10px;
    }

    .el-menu-vertical-demo {
        height: calc(100vh - 375px);
        min-height: 500px;
        overflow: auto;
        border: solid 1px #e6e6e6;
        border-top: none;
    }

    .page_content {
        height: calc(100vh - 40px);
    }

    //考生信息
    .stuInfo {
        border: 1px solid @primary_b;
        border-radius: 5px;
    }

    .el-aside {
        .dtk_all {
            border: 1px solid rgb(227 234 246);
            margin-top: 10px;
            height: calc(100vh - 380px);
            overflow: auto;
        }

        .dtk_all::-webkit-scrollbar {
            display: none;
        }

        .dtk_h {
            background-color: #f3f3f3;
            padding: 10px;
            margin: 0 10px;
            font-weight: 700;
            border-left: 3px solid #409EFF;
        }

        ul {
            margin: 0;
            padding: 0;
            margin-right: 5px;
        }

        li {
            list-style-type: none;
            float: left;
            border: 1px solid #f3f3f3;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 14px;
            margin-left: 3px;
            margin-bottom: 3px;
            cursor: pointer;
        }
    }

    .stem {
        font-size: 18px;
    }

    .all_subject {
        height: calc(100vh - 150px);
        overflow: auto;

        p {
            margin: 0;
            padding: 0;
        }

        ul li {
            list-style-type: none;
            line-height: 30px;

            .el-radio__label {
                font-size: 18px;
            }

        }
    }

    .all_subject::-webkit-scrollbar {
        display: none;
    }

    .el-radio__input, .el-radio__label, .el-checkbox__input, .el-checkbox__label {
        float: left;
    }

    .el-radio__inner, .el-checkbox__inner {
        margin-top: 2px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/Examination.vue